import { createTranslations } from '@npco/utils-translations'

export const maximumLimitListItemsTranslations = createTranslations({
  sectionTitle: 'Limits',
  maximumTransferLimit: 'Maximum Transfer Limit',
  dailyMaximumLimit: 'Daily Maximum Limit',
  dailyMaximumLimitInfo: 'This limit will reset daily at 12AM AEDT.',
})
